export const getUserDetail = () => {
  let user = JSON.parse(localStorage.getItem("userDetail"));
  return user?.accessToken ? user : null;
};

export const setUsetDetailToLocalStorage = (user) => {
  localStorage.setItem("userDetail", JSON.stringify(user));
};

export const clearLocalStorage = () => {
  localStorage.clear();
};
